// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8b2d9fa0","453":"302e1d5a"}[chunkId] + ".chunk.js";
};